const TrustBar = () => {
  const stats = [
    { icon: 'ri-scissors-cut-line', value: '55+', label: 'Years Experience' },
    { icon: 'ri-user-heart-line', value: '3,500+', label: 'Happy Clients' },
    { icon: 'ri-star-line', value: '5.0', label: 'Google Rating' },
    { icon: 'ri-home-line', value: 'House Calls', label: 'Available' },
  ];

  return (
    <section className="bg-white py-12 border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="flex justify-center mb-3">
                <div className="w-12 h-12 bg-[#C4A962]/10 rounded-full flex items-center justify-center">
                  <i className={`${stat.icon} text-[#C4A962] text-2xl`}></i>
                </div>
              </div>
              <div className="text-3xl font-bold text-gray-900 mb-1">{stat.value}</div>
              <div className="text-sm text-gray-600">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustBar;